import { Page } from "@betomorrow/micro-stores"
import {
  BoxSubscriptionItemDto,
  BoxSubscriptionItemDtoSchema,
} from "@modules/boxSubscription/gateway/boxSubscriptionApiDto"
import { BoxSubscriptionApiGateway } from "@modules/boxSubscription/gateway/boxSubscriptionApiGateway"
import { CouponInput } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PauseInputDto } from "@modules/common/pauseObject/gateway/pauseApiDto"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { Paginated, toPage } from "@modules/utils/paginated"

export class BoxSubscriptionApi implements BoxSubscriptionApiGateway {
  private baseUrl = "/box/members"

  constructor(private api: ApiClient) {}

  async getBoxSubscriptions(memberId: string, page?: number, size?: number): Promise<Page<BoxSubscriptionItemDto>> {
    const resultDto = await this.api.get<Paginated<BoxSubscriptionItemDto>>(
      `${this.baseUrl}/${memberId}/subscriptions`,
      {
        params: {
          page: page ?? 0,
          size: size ?? 10,
        },
      },
    )

    const pageResult = toPage(resultDto.data)
    return {
      ...pageResult,
      content: pageResult.content.map((boxSubscription) => BoxSubscriptionItemDtoSchema.parse(boxSubscription)),
    }
  }

  async deleteSubscription(
    memberId: string,
    subscriptionId: string,
    cancelAtPeriodEnd: boolean,
    endPeriodInMonths?: number,
  ): Promise<void> {
    const payload = endPeriodInMonths ? { cancelAtPeriodEnd, endPeriodInMonths } : { cancelAtPeriodEnd }
    await this.api.delete(`${this.baseUrl}/${memberId}/subscriptions/${subscriptionId}`, {
      data: payload,
    })
  }

  async removeSubscriptionDiscount(memberId: string, subscriptionId: string): Promise<void> {
    await this.api.delete(`${this.baseUrl}/${memberId}/subscriptions/${subscriptionId}/coupons`)
  }

  async applySubscriptionDiscount(memberId: string, subscriptionId: string, coupon: CouponInput): Promise<void> {
    await this.api.post(`${this.baseUrl}/${memberId}/subscriptions/${subscriptionId}/coupons`, coupon)
  }

  async pauseSubscription(memberId: string, subscriptionId: string, pause: PauseInputDto): Promise<void> {
    await this.api.post(`${this.baseUrl}/${memberId}/subscriptions/${subscriptionId}/pause`, pause)
  }

  async resumeSubscription(memberId: string, subscriptionId: string): Promise<void> {
    await this.api.post(`${this.baseUrl}/${memberId}/subscriptions/${subscriptionId}/resume`)
  }
}
